import { ConfigProvider, Empty, message, Modal, Table } from 'antd'
import Search from '../../components/SearchFilter'
import { useEffect, useState } from 'react'
import { getSupplierId, isResponseCodeSuccess } from '../../tools/util'
import { CheckOutlined } from '@ant-design/icons'
import { GET_PRODUCTCHILDLIST } from '@/api/MaterialApi'

interface Props {
  open: boolean
  onCancel: () => void
  onRowSelect: (record: any) => void
  shipperCode?: string
}

const MaterialCodeModal2 = (props: Props) => {
  const { open, onCancel, onRowSelect, shipperCode } = props
  const [selectList, setSelectList] = useState<any[]>([])
  const [loading, setLoading] = useState<boolean>(false)

  // useEffect(() => {
  //   if (open) {
  //     getList({})
  //   }
  // }, [open])

  const getList = async (params: any) => {
    try {
      setLoading(true)
      const res = await GET_PRODUCTCHILDLIST({
        ...params,
        pageNo: 1,
        pageSize: 30,
        supplierId: getSupplierId(),
        shipperCode,
      })
      if (isResponseCodeSuccess(res.code)) {
        setSelectList(res.data.content)
      } else {
        message.error(res.msg)
      }
    } catch (error) {
      message.error('获取物料列表失败')
    } finally {
      setLoading(false)
    }
  }

  // 表头
  const bankListColumn = [
    {
      key: 'code',
      dataIndex: 'code',
      title: '物料编码',
    },
    {
      key: 'name',
      dataIndex: 'name',
      title: '名称',
    },
    {
      key: 'brandName',
      dataIndex: 'brandName',
      title: '品牌',
    },
    {
      key: 'manuCode',
      dataIndex: 'manuCode',
      title: '规格型号',
    },
    // {
    //   key: 'unitName',
    //   dataIndex: 'unitName',
    //   title: '基本单位',
    // },
    {
      key: '',
      dataIndex: '',
      title: '操作',
      render: (text: any, record: any) => {
        return (
          <span className="primaryBtn" onClick={() => onRowSelect(record)}>
            <CheckOutlined />
          </span>
        )
      },
    },
  ]

  return (
    <>
      <Modal
        open={open}
        title="选择物料"
        width={900}
        footer={null}
        style={{ top: '10%' }}
        bodyStyle={{
          height: '600px',
        }}
        maskClosable={false}
        keyboard={false}
        onCancel={onCancel}
        destroyOnClose
      >
        <Search
          hideScheme
          key="MATERIALCODEMODAL"
          keyName="MATERIALCODEMODAL"
          ScreenKey="MATERIALCODEMODAL"
          fieldsData={['name', 'code', 'brand', 'model']}
          onSearch={getList}
        />

        <ConfigProvider
          renderEmpty={() => (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="先请输入物料相关信息进行搜索"
            ></Empty>
          )}
        >
          <Table
            rowKey="mdmId"
            dataSource={selectList}
            columns={bankListColumn}
            loading={loading}
            style={{ height: '480px', overflowY: 'auto' }}
            scroll={{ y: 'auto' }}
            pagination={false}
            // onRow={(record) => ({
            //   onClick: () => setSelect(record),
            // })}
          />
        </ConfigProvider>
        <div style={{ color: '#ccc' }}>
          一次最多支持展示30条结果，如有需要请精确查询条件
        </div>
      </Modal>
    </>
  )
}
export default MaterialCodeModal2
import { ConfigProvider, Empty, message, Modal, Table } from 'antd'
import Search from '../../components/SearchFilter'
import { useEffect, useState } from 'react'
import { getSupplierId, isResponseCodeSuccess } from '../../tools/util'
import { CheckOutlined } from '@ant-design/icons'
import { GET_PRODUCTCHILDLIST } from '@/api/MaterialApi'

interface Props {
  open: boolean
  onCancel: () => void
  onRowSelect: (record: any) => void
  shipperCode?: string
}

const MaterialCodeModal2 = (props: Props) => {
  const { open, onCancel, onRowSelect, shipperCode } = props
  const [selectList, setSelectList] = useState<any[]>([])
  const [loading, setLoading] = useState<boolean>(false)

  // useEffect(() => {
  //   if (open) {
  //     getList({})
  //   }
  // }, [open])

  const getList = async (params: any) => {
    try {
      setLoading(true)
      const res = await GET_PRODUCTCHILDLIST({
        ...params,
        pageNo: 1,
        pageSize: 30,
        supplierId: getSupplierId(),
        shipperCode,
      })
      if (isResponseCodeSuccess(res.code)) {
        setSelectList(res.data.content)
      } else {
        message.error(res.msg)
      }
    } catch (error) {
      message.error('获取物料列表失败')
    } finally {
      setLoading(false)
    }
  }

  // 表头
  const bankListColumn = [
    {
      key: 'code',
      dataIndex: 'code',
      title: '物料编码',
    },
    {
      key: 'name',
      dataIndex: 'name',
      title: '名称',
    },
    {
      key: 'brandName',
      dataIndex: 'brandName',
      title: '品牌',
    },
    {
      key: 'manuCode',
      dataIndex: 'manuCode',
      title: '规格型号',
    },
    // {
    //   key: 'unitName',
    //   dataIndex: 'unitName',
    //   title: '基本单位',
    // },
    {
      key: '',
      dataIndex: '',
      title: '操作',
      render: (text: any, record: any) => {
        return (
          <span className="primaryBtn" onClick={() => onRowSelect(record)}>
            <CheckOutlined />
          </span>
        )
      },
    },
  ]

  return (
    <>
      <Modal
        open={open}
        title="选择物料"
        width={900}
        footer={null}
        style={{ top: '10%' }}
        bodyStyle={{
          height: '600px',
        }}
        maskClosable={false}
        keyboard={false}
        onCancel={onCancel}
        destroyOnClose
      >
        <Search
          hideScheme
          key="MATERIALCODEMODAL"
          keyName="MATERIALCODEMODAL"
          ScreenKey="MATERIALCODEMODAL"
          fieldsData={['name', 'code', 'brand', 'model']}
          onSearch={getList}
        />

        <ConfigProvider
          renderEmpty={() => (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="先请输入物料相关信息进行搜索"
            ></Empty>
          )}
        >
          <Table
            rowKey="mdmId"
            dataSource={selectList}
            columns={bankListColumn}
            loading={loading}
            style={{ height: '480px', overflowY: 'auto' }}
            scroll={{ y: 'auto' }}
            pagination={false}
            // onRow={(record) => ({
            //   onClick: () => setSelect(record),
            // })}
          />
        </ConfigProvider>
        <div style={{ color: '#ccc' }}>
          一次最多支持展示30条结果，如有需要请精确查询条件
        </div>
      </Modal>
    </>
  )
}
export default MaterialCodeModal2
